import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'instructionalVideoLink',
    standalone: false
})
export class InstructionalVideoLinkPipe implements PipeTransform {
  private readonly links: Record<string, string> = {
    nl: 'https://youtu.be/kgWqj9IOt9E',
    fr: 'https://youtu.be/2QwM3xtQtDQ',
    en: 'https://youtu.be/npWC9YdF5W0',
  };

  public transform(currentLang: string): string {
    return this.links[currentLang] ?? this.links['en'];
  }
}
